module.exports = __webpack_public_path__ + "img/rain-gauge.655ca50b.png";